;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.global = (function () {
    function onLoad () {
      // console.log('global init')

      $(document).trigger('eah-init')
    }

    return {
      onLoad
    }
  })()

  $(window).on('load', eah.global.onLoad)
}(jQuery, window))
